import { SubscriptionIntervalTypes } from '../../utils/constants';

export const platform = 'web';

export const SubscriptionTerms = {
    ANNUAL: 'annual',
    MONTHLY: 'monthly',
};

export const intervalToBillingCycle = {
    [SubscriptionIntervalTypes.YEAR]: SubscriptionTerms.ANNUAL,
    [SubscriptionIntervalTypes.MONTH]: SubscriptionTerms.MONTHLY,
};

export const SubscriptionTypes = {
    POWER: 'power',
    FREE: 'free',
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
};

export const ProfileTypes = {
    SELF: 'self',
    OTHER: 'other',
};

export const ThirdPartyProviders = {
    GLOBAL_PRIVILEGES: 'Global Privileges',
};

export const ThirdPartyTiers = {
    PREMIUM: 'Premium',
};

export const SubscriptionGateways = {
    STRIPE: 'Stripe',
    APPLE: 'Apple',
};

export const UpgradeFunnelEvents = {
    CTA_CLICKED: 'upgrade_cta_clicked',
    CHANGE_CARD_CLICKED: 'change_card_clicked',
    UPGRADE_FAILED: 'upgrade_failed',
};

export const UpgradeFailureTypes = {
    CARD_DECLINED: 'card_declined',
    INSUFFICIENT_FUNDS: 'insufficient_funds',
    PROCESSING_ERROR: 'processing_error',
    UNKNOWN: 'unknown',
};

export const PowerFunnelEvents = {
    POWER_PAYWALL_VIEWED: 'power_paywall_viewed',
    POWER_CHECKOUT_STARTED: 'power_checkout_started',
    POWER_PURCHASE_SUCCEEDED: 'power_purchase_succeeded',
    POWER_UPGRADE_FLOW_ABANDONED: 'power_upgrade_flow_abandoned',
};

export const ReferralEvents = {
    REFERRAL_LANDING_PAGE_VIEWED: 'referral_landing_page_viewed',
    // Replaces the deprecated referral_self_attempt_blocked (DS-99 / ENG-2315): generalized to
    // every code-application failure via error_state, of which self-referral is one value.
    REFERRAL_ATTEMPT_FAILED: 'referral_attempt_failed',
    REFERRAL_LINK_SHARED: 'referral_link_shared',
    REFERRAL_CODE_COPY: 'referral_code_copy',
    REFERRAL_CODE_APPLY: 'referral_code_apply',
};

// error_state values on referral_attempt_failed (DS-99 / ENG-2315). code_expired,
// incorrect_plan_interval, and code_redeemed cannot be distinguished from the current apply
// response (they collapse into CODE_INVALID) — see the API-gap notes on ENG-2315.
export const ReferralAttemptErrorStates = {
    CODE_INVALID: 'code_invalid',
    CODE_EXPIRED: 'code_expired',
    SELF_CODE: 'self_code',
    REFERRER_MEMBER_EXPIRED: 'referrer_member_expired',
    INCORRECT_PLAN_INTERVAL: 'incorrect_plan_interval',
    CODE_REDEEMED: 'code_redeemed',
};

export const ReferralShareMethods = {
    NATIVE: 'native',
    COPY_LINK: 'copy_link',
};

export const PowerFunnelUserStatuses = {
    FREE: 'free',
    MONTHLY: 'monthly',
    POWER_PAST_DUE: 'power_past_due',
};

// Numeric provider IDs from memberThirdPartyPlans[].providerId — key off these,
// not the display label (which can change). Source of truth: backend.
export const ThirdPartyProviderIds = {
    GLOBAL_PRIVILEGES: 1,
    FABLETICS: 2,
};

export const PowerFunnelSurfaces = {
    COLLEGE_COACH_VIEW: 'web_college_coach_view',
    COLLEGE_CORNER: 'web_college_corner',
    COLLEGE_SEARCH_PAGE: 'web_college_search_page',
    EVENT_GP_FIND_ACCOMMODATIONS: 'web_event_profile_find_accommodations',
    EVENT_GP_FIND_ACCOMMODATIONS_REGISTRATION_CONFIRMATION: 'web_event_profile_find_accommodations_registration_confirmation',
    EVENT_PROFILE_UPGRADE: 'web_event_profile_upgrade',
    EVENT_REGISTRATION: 'web_event_registration',
    EVENT_REGISTRATION_SWITCH_DIVISION: 'web_event_registration_switch_division',
    HEADER: 'web_header',
    HOME: 'web_home',
    LOCAL_LEADERBOARD: 'web_player_local_leaderboard',
    LOCAL_RANKINGS: 'web_player_local_ranking',
    MENU: 'web_menu',
    PLAYER_PROFILE: 'web_player_profile',
    PLAYER_PROFILE_COLLEGE_PROSPECT: 'web_player_profile_college_prospect',
    PLAYER_SEARCH_PAGE: 'web_player_search_page',
    POWER_CAMPAIGN_LINK: 'web_power_campaign_link',
    POWER_PERKS_PAGE: 'web_perks_page',
    RALLY: 'web_rally',
    REFERRAL_LANDING_PAGE: 'web_referral_landing_page',
    SEARCH_FOOTER: 'web_search_footer',
    SUBSCRIPTION_SETTINGS: 'web_subscription_settings',
    UNKNOWN: 'web_unknown',
};

export const PowerFunnelGatedFeatures = {
    ACTIVITY_STATS: 'web_activity_stats',
    ANNUAL_POWER_DIVISION: 'web_annual_power_division',
    COLLEGE_COACH_VIEWS: 'web_college_coach_views',
    COLLEGE_CORNER_CONFERENCES_FILTER: 'web_college_corner_conferences_filter',
    COLLEGE_CORNER_DIVISIONS_FILTER: 'web_college_corner_divisions_filter',
    COLLEGE_CORNER_MORE_FILTER: 'web_mobile_college_corner_more_filter',
    COLLEGE_CORNER_NATIONALITIES_FILTER: 'web_college_corner_nationalities_filter',
    COLLEGE_CORNER_SEARCH_RESULTS: 'web_college_corner_search_results',
    COLLEGE_CORNER_SNAPSHOT_DATE_FILTER: 'web_college_corner_snapshot_date_filter',
    COLLEGE_CORNER_FIT_TOOL_FILTER: 'web_college_corner_fit_tool_filter',
    EVENT_REGISTRATION: 'web_event_registration',
    FABLETICS: 'web_fabletics_benefit',
    GLOBAL_PRIVILEGES: 'web_global_privileges_benefit',
    HOW_POWER_WORKS: 'web_how_power_works',
    LEADERBOARD: 'web_player_local_leaderboard',
    LOCALIZED_RANKINGS: 'web_player_local_rankings',
    PERFORMANCE_STATS: 'web_performance_stats',
    PLAYER_METRICS: 'web_player_metrics',
    PLAYER_COLLEGES_FILTER: 'web_player_colleges_filter',
    PLAYER_MORE_MOBILE_FILTER: 'web_player_more_mobile_filter',
    CPP_GET_POWER_CTA: 'cpp_get_power_cta',
    CPP_DISCOVERY_BANNER_CTA: 'cpp_discovery_banner_cta',
    CPP_ACADEMICS_EDIT_LOCKED: 'cpp_academics_edit_locked',
    CPP_TARGET_COLLEGES_LOCKED: 'cpp_target_colleges_locked',
    CPP_COACH_ACTIVITY_LOCKED: 'cpp_coach_activity_locked',
    CPP_COLLEGE_COACH_VIEWS_LOCKED: 'cpp_college_coach_views_locked',
    CPP_COLLEGE_FIT_LOCKED: 'cpp_college_fit_locked',
    CPP_RECOMMENDED_EVENTS_LOCKED: 'cpp_recommended_events_locked',
    CPP_RECRUITING_STATUS_LOCKED: 'cpp_recruiting_status_locked',
    CPP_SOCIAL_HANDLES_LOCKED: 'cpp_social_handles_locked',
    CPP_RECRUITING_AGENCY_LOCKED: 'cpp_recruiting_agency_locked',
    CPP_RECRUITING_VIDEOS_LOCKED: 'cpp_recruiting_videos_locked',
    POWER_PERKS_BANNER: 'web_power_perks_banner',
    POWER_PERKS_CARD: 'web_power_perks_card',
    POWER_PERKS_FOOTER: 'web_power_perks_footer',
    REFERRAL_CODE_POPUP: 'web_referral_code_popup',
    SAVED_PLAYER_LIST: 'web_saved_player_list',
    SEARCH_RESULTS: 'web_search_results',
    // Fallback when a user reaches the funnel with no prior gated-surface interaction
    // (e.g. navigated straight to the subscription page). Keeps gatedFeature non-null.
    WEB_DIRECT_TO_SUBSCRIPTION: 'web_direct_to_subscription',
    // Rally chatbot gated features — values are cross-platform (web + iOS) DS contract,
    // not the web_-prefixed convention above.
    RALLY_ANALYSIS: 'rally_analysis',
    RALLY_EVENT_RECOMMENDATIONS: 'rally_event_recommendations',
};

export const RallyEventRecEvents = {
    RALLY_EVENT_REC_REQUESTED: 'rally_event_rec_requested',
    RALLY_EVENT_REC_RETURNED: 'rally_event_rec_returned',
    RALLY_EVENT_REC_ZERO_RESULTS: 'rally_event_rec_zero_results',
    RALLY_EVENT_LINK_CLICKED: 'rally_event_link_clicked',
    RALLY_EVENT_CHECKOUT_STARTED: 'rally_event_checkout_started',
    RALLY_EVENT_REGISTRATION_COMPLETED: 'rally_event_registration_completed',
};

export const CppEvents = {
    CPP_PLAYER_ENGAGEMENT: 'cpp_player_engagement',
    CPP_COACH_ENGAGEMENT: 'cpp_coach_engagement',
};

export const CppPlayerActions = {
    CPP_TAB_VIEWED: 'cpp_tab_viewed',
    CPP_TARGET_COLLEGE_ADDED: 'cpp_target_college_added',
    CPP_TARGET_COLLEGE_REMOVED: 'cpp_target_college_removed',
    CPP_COLLEGE_FIT_USED: 'cpp_college_fit_used',
    CPP_RECRUITING_STATUS_UPDATED: 'cpp_recruiting_status_updated',
    CPP_ACADEMICS_UPDATED: 'cpp_academics_updated',
    CPP_RECOMMENDED_EVENT_CLICKED: 'cpp_recommended_event_clicked',
    CPP_ALERT_COLLEGE_TOGGLED: 'cpp_alert_college_toggled',
    CPP_COACH_VIEW_ADD_TO_LIST: 'cpp_coach_view_add_to_list',
    CPP_INTERESTED_IN_ME_VIEWED: 'cpp_interested_in_me_viewed',
    CPP_DISCOVERY_BANNER_VIEWED: 'cpp_discovery_banner_viewed',
    CPP_DISCOVERY_BANNER_CLICKED: 'cpp_discovery_banner_clicked',
    CPP_PLAYER_VIDEOS_MODAL_OPENED: 'cpp_player_videos_modal_opened',
    CPP_PLAYER_VIDEOS_MODAL_DISMISSED: 'cpp_player_videos_modal_dismissed',
    CPP_PLAYER_VIDEO_ADDED: 'cpp_player_video_added',
    CPP_PLAYER_VIDEO_UPDATED: 'cpp_player_video_updated',
    CPP_PLAYER_VIDEO_DELETED: 'cpp_player_video_deleted',
    CPP_PLAYER_VIDEOS_REORDERED: 'cpp_player_videos_reordered',
    CPP_PLAYER_VIDEO_SAVE_FAILED: 'cpp_player_video_save_failed',
};

export const CppCoachActions = {
    CPP_COACH_JUNIOR_PROSPECTS_TAB_VIEWED: 'cpp_coach_junior_prospects_tab_viewed',
    CPP_COACH_PROSPECT_LIKED: 'cpp_coach_prospect_liked',
    CPP_COACH_PROSPECT_ALERT_TOGGLED: 'cpp_coach_prospect_alert_toggled',
    CPP_COACH_CONTACT_INITIATED: 'cpp_coach_contact_initiated',
    CPP_COACH_DISCOVERY_BANNER_VIEWED: 'cpp_coach_discovery_banner_viewed',
    CPP_COACH_DISCOVERY_BANNER_CLICKED: 'cpp_coach_discovery_banner_clicked',
    CPP_COACH_RECRUITING_VIDEOS_VIEWED: 'cpp_coach_recruiting_videos_viewed',
    CPP_COACH_VIDEO_PLAYED: 'cpp_coach_video_played',
};

export const CppCoachSurfaces = {
    COLLEGE_CORNER: 'college_corner',
    DISCOVERY_BANNER: 'discovery_banner',
    PLAYER_PROFILE: 'player_profile',
};

export const CppBannerPlacements = {
    HOME: 'home',
};

export const CppContactMethods = {
    PHONE: 'phone',
    TEXT: 'text',
    EMAIL: 'email',
};

export const CppUserRoles = {
    CPP_PLAYER: 'cpp_player',
    CPP_COACH: 'cpp_coach',
};

export const HotelPlannerTracking = {
    FIND_ACCOMMODATIONS_SURFACE: 'find_accommodations',
    NOT_READY_FOR_POWER_POPUP_SURFACE: 'not_ready_for_power_popup',
    HOTEL_PLANNER_SEARCH_CLICK: 'gp_clicked_go_to_hotel_planner',
    EVENT_LOCATION_MODULE_IMPRESSION: 'hp_event_location_module_impression',
};

export const HotelPlannerCustomSurfaceParam = {
    [PowerFunnelSurfaces.EVENT_GP_FIND_ACCOMMODATIONS]: 'EventOverview',
    [PowerFunnelSurfaces.EVENT_GP_FIND_ACCOMMODATIONS_REGISTRATION_CONFIRMATION]: 'RegistrationConfirmation',
};

export const LeaderboardTrackingData = {
    TITLE: 'view_leaderboard_modal',
    TOP_ONE_HUNDRED_TYPE: 'topOneHundred',
    CLOSE_IN_RANK_TYPE: 'relative',
    LOCALIZED_RANKINGS_FEATURE: 'player local rankings',
    LEADERBOARD_FEATURE: 'player leaderboard',
};

// Imported Event Page instrumentation (TMS-2221). Names come from DS-149's engineering
// acceptance criteria verbatim: snake_case events and a PascalCase ImportedEventId, both
// against this file's own conventions, because the analytics contract is owned by Data
// Science and the warehouse columns are already spec'd to these strings.
export const ImportedEventAnalyticsEvents = {
    PAGE_VIEWED: 'imported_event_page_viewed',
    PAGE_SHARED: 'imported_event_page_shared',
};

// camelCase per DS-149's Eng criteria, which the ticket names as the contract. Its QA
// criteria spell the same values `results_tab_card` / `Overview tab card`; if DS settles on
// snake_case only these three literals change.
export const ImportedEventEntryPoints = {
    RESULTS_TAB_CARD: 'resultsTabCard',
    OVERVIEW_TAB_CARD: 'overviewTabCard',
    EVENTS_TAB_CARD: 'eventsTabCard',
};

// Which surface a share was taken from. The profile values are the ImportedEventEntryPoints
// strings verbatim, so arrival surface and share surface are one comparable dimension rather
// than two vocabularies with a mapping between them. No page prefix is needed: the Imported
// Event Page's own tabs are Players and Results, so an Overview or Events tab card can only be
// the player profile, and IMPORTED_EVENT_PAGE is the explicit contrast within this same enum.
//
// Note the Overview value cannot occur yet: Overview renders its cards with force.cardView,
// which turns showShareAction off, so only the Events tab has a share control today. It is
// declared so enabling that control needs no analytics change. There is no results-tab value
// because the Results tab has no share affordance at all.
export const ImportedEventShareSurfaces = {
    IMPORTED_EVENT_PAGE: 'importedEventPage',
    OVERVIEW_TAB_CARD: 'overviewTabCard',
    EVENTS_TAB_CARD: 'eventsTabCard',
};

// A card knows which surface it sits on as an entry point; this translates that into the share
// vocabulary. The two are spelled identically today, but they are settled separately — DS may
// change entryPoint's casing without touching shareSurface — and mapping explicitly means an
// edit to one enum can never silently rewrite the other column. Entry points with no share
// affordance (the Results tab) are deliberately absent and resolve to null.
export const ShareSurfaceByEntryPoint = {
    [ImportedEventEntryPoints.OVERVIEW_TAB_CARD]: ImportedEventShareSurfaces.OVERVIEW_TAB_CARD,
    [ImportedEventEntryPoints.EVENTS_TAB_CARD]: ImportedEventShareSurfaces.EVENTS_TAB_CARD,
};
